module.exports = __webpack_public_path__ + "img/homeBlack.6e8b5a1c.svg";